import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger
} from "@/shared/ui/alert-dialog.tsx"
import { Trash2 } from "lucide-react";
import { useDeleteImage } from "../api";
import { Button } from "@/shared/ui/button.tsx";


const DeleteConfirmation = ({ image_id }: { image_id: number }) => {

  const { deleteImage } = useDeleteImage()

  const deleteEventHandler = () => {
    deleteImage(image_id)
  }

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button onClick={e => e.stopPropagation()} size="icon" className="rounded-full bg-white hover:text-white animate-wave p-2 absolute bottom-2 size-7 right-2 text-black z-50"><Trash2 color="red" /></Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone. This will permanently delete this
            image .
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={(e) => {
            e.stopPropagation()
            deleteEventHandler()
          }}>Continue</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default DeleteConfirmation;
